import { eEstadoMaestro } from "../common/enumModel";
import { IFilterTipoAccidenteModel } from "../interfaces/tipo-accidente/IFilterTipoAccidenteModel";

export class FilterTipoAccidenteModel implements IFilterTipoAccidenteModel {    
    idTipoAccidente: number[];
    nombre: string;
    idEstado: eEstadoMaestro;
    page: number;
    pageSize: number;
    
    constructor(){
        this.idTipoAccidente = new Array<number>();
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.page = 1;
        this.pageSize = 30;
    }
}